export const LOAD_PARTNER_VERIFICATIONS_SUCCEEDED = 'LOAD_PARTNER_VERIFICATIONS_SUCCEEDED';
export const LOAD_PARTNER_VERIFICATIONS_SUMMARY_SUCCEEDED = 'LOAD_PARTNER_VERIFICATIONS_SUMMARY_SUCCEEDED';
